import classes from "./expand.module.css"
import classNames from "classnames"
import React from "react"
import { ArrowDownIcon } from "../../../icons"
import CustomIconButton from "../CustomIconButton"

export interface RotatingButtonProps {
  onClick?: () => void
  className?: string
  icon?: React.ReactNode
  expanded?: boolean
  color?: string
  size?: string | number
}

export const ExpandButton = ({
  onClick,
  icon,
  expanded,
  color,
  size,
  ...other
}: RotatingButtonProps) => {
  return (
    <CustomIconButton
      onClick={onClick}
      icon={
        <ArrowDownIcon
          size={size}
          color={color}
          className={classNames(classes.root, { [classes.expanded]: expanded })}
        />
      }
      {...other}
    />
  )
}

export const ExpandControl = ({
  onClick,
  expanded,
  color,
  size,
}: RotatingButtonProps) => {
  return (
    <ArrowDownIcon
      size={size}
      color={color}
      className={classNames(classes.root, "cursor-pointer", {
        [classes.expanded]: expanded,
      })}
      onClick={onClick}
    />
  )
}
